import React, { useMemo } from "react";
import { useApp } from "../contexts/AppContext";

export default function SnowEffect() {
  const { settings } = useApp();
  const flakes = useMemo(
    () =>
      Array.from({ length: 60 }).map((_, i) => ({
        left: Math.random() * 100,
        size: 2 + Math.random() * 6,
        duration: 6 + Math.random() * 12,
        delay: Math.random() * -20,
        opacity: 0.4 + Math.random() * 0.6,
      })),
    []
  );
  if (!settings.snow_enabled) return null;
  return (
    <div className="pointer-events-none fixed inset-0 z-[60] overflow-hidden" data-testid="snow-effect">
      {flakes.map((f, i) => (
        <span
          key={i}
          className="snowflake"
          style={{
            left: `${f.left}%`,
            width: `${f.size}px`,
            height: `${f.size}px`,
            opacity: f.opacity,
            animationDuration: `${f.duration}s`,
            animationDelay: `${f.delay}s`,
          }}
        />
      ))}
    </div>
  );
}
